import { FunctionComponent } from 'react'

type BottomBannerProps = {
	//
}

const BottomBanner: FunctionComponent<BottomBannerProps> = props => (
	<div className="ad bottom-banner" />
)

export default BottomBanner
